import React from "react";
import { Fragment } from "react";

import styles from "./HomePage.module.css";
import Card from "./UI/Card";
import gif from "../Assets/topshot.gif";
import Header from "./Header";
import List from "./UI/List";
import FadeInOnScroll from "./UI/FadeInOnScroll";

const HomePage = () => {
  const features = [
    "Captures the necessary flight parameters needed to simulate flight",
    "Very easy to use, even for someone who has never played",
    "Intuituive feedback provided to user",
  ];

  const benefits = [
    "Play disc golf indoors year-round",
    "Improve your disc golf mechanics",
    "Enjoy the game while at your local barcade with friends",
  ];

  return (
    <Fragment>
      <Header
        intro="Hyzerberg Technologies: The Hyzerberg 1.0"
        main="Creating technology to help grow a budding sport."
      ></Header>

      <div className={styles.second}>
        <FadeInOnScroll>
          <img src={gif} alt="gif" className={styles.gif}></img>
        </FadeInOnScroll>
      </div>

      <div className={styles.content}>
        <FadeInOnScroll>
          <List header="Features" items={features} />
          </FadeInOnScroll>
          <FadeInOnScroll>
          <List header="Benefits" items={benefits} />

          </FadeInOnScroll>
        
      </div>

      <div className={styles.blog}>
        <FadeInOnScroll>
          <Card>
            <p className={styles.header}>Blog</p>
            <p className={styles.card}>
              3/27/23: The team has been hard at work recently, getting our new
              Seeed Computer J1020 setup with an Arducam camera. These new
              additions are explained in detail on the Current Status page. We
              also filmed an awesome commercial to potentially pitch the product
              to customers.
            </p>
            <p className={styles.card}>
              4/24/23: We had a great final Capstone Symposium
              this last weekend. We presented our project in front of 
              the entire Engineering department as well as multiple 
              special guests. In the last week or so, we moved our computer
              and camera setup into the Capstone flex space. We troubleshooted
              the computer as we were unfamiliar with Linux and had quite a few
              compatibility issues with OpenCV, Python, CUDA, etc. Many of our issues
              had to do with the frame rate and overall speed of the J1020
              as well as some overheating issues. We realized that a more simple 
              live demo was the best course of action and ended up focusing on 
              initial velocity and nose angle of the disc. We cut down on our code 
              and improved our accuracy and ended up with a really cool live 
              demo that was evidence of the amount of work we put in.
            </p>
          </Card>
        </FadeInOnScroll>
      </div>
    </Fragment>
  );
};

export default HomePage;
